import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaShoppingCart,
  FaRocket,
  FaMobileAlt,
  FaLock,
  FaGlobe,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const BestEcommerceWebsiteDevelopmentInBurDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Best E-commerce Website Development in Bur Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={
          <Subheading>Launch Your Online Store with Confidence</Subheading>
        }
        heading={
          <Heading>
            Best{" "}
            <span tw="text-primary-500">E-commerce Website Development</span> in
            Bur Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we provide top-tier e-commerce website
            development services in **Bur Dubai**, designed to drive sales,
            enhance user experience, and grow your brand. Our solutions are
            tailored to meet the unique needs of businesses in this vibrant
            commercial hub.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1661956602868-6ae368943878?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // E-commerce shopping interface
          "https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Development team working
          "https://images.unsplash.com/photo-1577962917302-cd874c4e31d2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Dubai cityscape
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Start Your Project Now"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Your Go-To Partner for E-commerce Success in Bur Dubai"
        description="We deliver innovative, scalable, and secure e-commerce solutions."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Custom Storefronts",
            description:
              "Tailored designs to showcase your products effectively.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Performance",
            description:
              "Optimized websites for quick load times and seamless browsing.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile-First Design",
            description:
              "Responsive layouts for an exceptional mobile shopping experience.",
          },
          {
            icon: <FaLock color="#ff5464" size={40} />,
            title: "Secure Transactions",
            description:
              "Robust security features to protect your customers’ data.",
          },
          {
            icon: <FaGlobe color="#ff5464" size={40} />,
            title: "Localized Solutions",
            description: "Built with Bur Dubai’s market and culture in mind.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Proven Excellence",
            description:
              "Trusted by businesses in Bur Dubai for top-quality results.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Proven Process for E-commerce Development in Bur Dubai"
        description={
          <Description>
            We follow a streamlined approach to deliver high-performing
            e-commerce websites:
            <ul tw="mt-4 list-disc pl-6">
              <li>
                Consultation: Understand your business goals and target
                audience.
              </li>
              <li>
                Design: Create visually appealing and user-friendly layouts.
              </li>
              <li>
                Development: Build scalable, secure, and feature-rich platforms.
              </li>
              <li>
                Integration: Add payment gateways, inventory systems, and more.
              </li>
              <li>
                Testing: Ensure flawless performance across devices and
                browsers.
              </li>
              <li>
                Launch & Support: Deploy your site and provide ongoing
                maintenance.
              </li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // E-commerce website mockup
          "https://images.unsplash.com/photo-1522542550221-31fd19575a2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Website development process
          "https://images.unsplash.com/photo-1483478550801-ceba5fe50e8e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Mobile e-commerce shopping
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Discover Our Process"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Driving E-commerce Success in Bur Dubai"
        description="See how we’ve transformed businesses with our e-commerce expertise."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Boosted Sales",
            description:
              "Increased online sales by 200% for a Bur Dubai retailer.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Improved Speed",
            description:
              "Reduced page load time by 50% for a local e-commerce site.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Customer Praise",
            description:
              "Achieved 95% customer satisfaction with seamless designs.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={
          <Subheading>Ready to Grow Your Online Business?</Subheading>
        }
        heading="Launch the Best E-commerce Website in Bur Dubai"
        description={
          <Description>
            Partner with MilaajBrandset to create a powerful e-commerce platform
            that stands out in Bur Dubai’s competitive market. Let’s turn your
            vision into reality.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1582213782179-e0d4d3cce817?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Bur Dubai marketplace
          "https://images.unsplash.com/photo-1571867424488-4565932edb41?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Online shopping on mobile
          "https://images.unsplash.com/photo-1560264280-88b68371db39?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Business handshake
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Get in Touch"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
